import * as R from 'ramda';

export const fitArray = <T>(array: T[], length: number, defaultValue?: T) => {
  if (length > array.length) {
    return R.concat(array, R.repeat(R.defaultTo('' as T, defaultValue), length - array.length));
  } else {
    return R.take(length, array);
  }
};
